import { FormField } from 'js/components/Form/CustomFields/types'

export default (formField: FormField) => {
    const { title, description, isMandatory } = formField

    return {
        title,
        description,
        required: isMandatory,
        ...getTypeProps(formField),
    }
}

const getTypeProps = (formField: FormField) => {
    const { fieldType, fieldOptions } = formField

    const options = fieldOptions.map((option) => ({
        label: option,
        value: option,
    }))

    switch (fieldType) {
        case 'textField':
            return {
                type: 'text',
            }
        case 'selectField':
            return {
                type: 'select',
                options,
                isClearable: true,
            }
        case 'multiSelectField':
            return {
                type: 'select',
                options,
                isMulti: true,
            }
        case 'dateField':
            return {
                type: 'date',
                isClearable: true,
            }
        case 'dateTimeField':
            return {
                type: 'datetime',
                isClearable: true,
            }
        case 'htmlField':
            return {
                type: 'rich',
                textSize: 'small',
            }
        case 'radioField':
            return {
                type: 'radio',
                options,
                size: 'small',
            }
        case 'checkboxField':
            return {
                type: 'checkboxes',
                options,
                size: 'small',
            }
        default:
            return {}
    }
}
